import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { API_URL } from '../utils/gameUtils';

export default function AdminLoginScreen({ onLoginSuccess }) {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/admin/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            if (response.ok) {
                const data = await response.json();
                onLoginSuccess(data.token);
            } else if (response.status === 503) {
                setError('管理機能が設定されていません');
            } else {
                const data = await response.json();
                setError(data.detail || 'パスワードが違います');
            }
        } catch (err) {
            setError('サーバーに接続できません');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center h-full p-6">
            <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-sm border border-gray-200">
                <div className="flex justify-center mb-6">
                    <div className="bg-orange-100 p-3 rounded-full">
                        <Lock className="w-8 h-8 text-orange-500" />
                    </div>
                </div>
                <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">管理者ログイン</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="パスワード"
                            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all"
                            autoFocus
                        />
                    </div>

                    {error && (
                        <p className="text-red-500 text-sm text-center font-medium">{error}</p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-orange-600 text-white font-bold py-3 rounded-lg hover:bg-orange-700 transition-colors shadow-md active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'ログイン中...' : 'ログイン'}
                    </button>
                </form>
            </div>
        </div>
    );
}
